import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AuthService } from '../../services/auth.service';
import { CityService } from '../../services/city.service';
import { EmailService } from '../../services/email.service';
import { GraphService } from '../../services/graph.service';
import { NotificationService } from '../../services/notification.service';
import { UtilService } from '../../services/util.service';
import { SendEmailDialog } from '../send-email-popup/send-email-popup.component';
import {
    City,
    CustomerLookup
} from '../../models/models';

@Component({
    selector: 'test-page',
    //styleUrls: ['./test-page.component.css'],
    templateUrl: './test-page.component.html',
    standalone: false
})
export class TestPageComponent {
    public orderNumber: string = '';
    public customerCode: string = '';
    public customerName: string = '';
    public testDate: Date = new Date();
    public testText: string = "";
    public cityID: number = 0;
    public city: City = {} as City;

    public testForm: UntypedFormGroup = new UntypedFormGroup({
        cityStateZipCtrl: new UntypedFormControl(''),
        cityCtrl: new UntypedFormControl('')
    });

    orderPlannedForm: UntypedFormGroup = new UntypedFormGroup({
        billToCtrl: new UntypedFormControl(''),
        carrierCtrl: new UntypedFormControl(''),
        originControl: new UntypedFormControl(''),
        destinationControl: new UntypedFormControl('')
    });

    constructor(private router: Router, public graphService: GraphService,
        private authService: AuthService, private cityService: CityService,
        private emailService: EmailService, public dialog: MatDialog,
        private notificationService: NotificationService,
        private titleService: Title, private utilService: UtilService) {
        this.titleService.setTitle('Test Page');
    }

    public testIsLoading() {
        this.utilService.isLoading = true;
        setTimeout(() => { this.utilService.isLoading = false }, 2000);
    }

    public testGraph() {
        this.graphService.getTeams().then((result) => {
            var ok = result;
        });
    }

    public getAvailableLoadsTeam() {
        this.graphService.getGroupByName('Available Loads').then((result) => {
            var ok = result;

            if (ok == null || ok.length < 1) {
                this.graphService.createGroup('Available Loads', ['corey@epilutions.com'], ['michaelj.simpson24@gmail.com']).then((teamResult) => {
                    var lol = teamResult;
                });
            }
        })
    }

    public getCheckCallNote() {
        var dateFrom = new Date();
        var dateTo = new Date(this.testDate);
        var modifiedByName = "Test User";
        this.testText = "LLD changed from "
            + dateFrom.toLocaleString()
            + " to "
            + dateTo.toLocaleString()
            //+ dateTo.toUTCString()
            //+ this.utilService.getCheckCallDateTime(dateTo);
        //+ this.utilService.getDateAsUTC(dateTo).toLocaleString()
        //+ this.utilService.getUTCDateAsLocalDate(dateTo).toLocaleString()
        + " by " + modifiedByName;
    }

    public onCustomerChange(evt: any, ctrl: string) {
        var val = this.orderPlannedForm.controls[ctrl].value;
        var selectedCustomer = val as CustomerLookup;
        console.log("onCustomerChange", evt, val, ctrl, selectedCustomer);
        if (selectedCustomer.customerCode) {
            this.customerCode = selectedCustomer.customerCode;
        }
        else if (!isNaN(evt)) {
            this.customerCode = val;
        }
        else {
            this.customerCode = "";
        }
    }

    public citySTChanged(evt: any) {
        var cityID = evt;
        console.log("citySTChanged", cityID, this.city);
        this.cityService.getCityByID(cityID).subscribe(result => {
            if (result.resultCollection.length > 0) {
                this.city = result.resultCollection[0];
                this.cityID = cityID;
                console.log("citySTChanged:customerCity", cityID, this.city, result);
            }
            else {
                this.notificationService.showWarning("Invalid or missing city.", "WARNING: Invalid City");
            }
        });
    }

    public sendEmail() {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            showEmailBody: true,
            showSubject: true,
            //contacts: contacts,
            emailTo: "",
            emailCC: "",
            ccEmails: "",
            emailSubject: "",
            emailBody: ""
        }

        const dialogRef = this.dialog.open(SendEmailDialog, dialogConfig);

        //console.log("sendOfferEmail", accountRep, offer);

        dialogRef.componentInstance.emailTo = "aforbes@epilutions.com";
        dialogRef.componentInstance.emailCC = "";
        dialogRef.componentInstance.ccEmails = [];
        dialogRef.componentInstance.emailSubject = "test";
        dialogRef.componentInstance.emailBody = "testing";
        //dialogRef.componentInstance.notes = dataItem.comment;

        dialogRef.afterClosed().subscribe(result => {
            //console.log(result);
            if (result.btnOK == true) {
                console.log("sendAvailableLoadOfferEmail", result);
                this.emailService.sendEmail(result.emailTo, result.emailCC, "", 0, result.emailSubject, result.emailBody).subscribe(result => {
                    var ok = result;
                },
                    err => {
                        console.log(err);
                    }
                );
            }
        });
    }

    public sendAvailableLoadOfferEmail(quoteOrderLineID: number) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            showEmailBody: false,
            showSubject: false,
            //contacts: contacts,
            emailTo: "",
            emailCC: "",
            ccEmails: "",
            emailSubject: "",
            emailBody: ""
        }

        const dialogRef = this.dialog.open(SendEmailDialog, dialogConfig);

        //console.log("sendOfferEmail", accountRep, offer);

        dialogRef.componentInstance.emailTo = "";
        dialogRef.componentInstance.emailCC = "";
        dialogRef.componentInstance.ccEmails = [];
        dialogRef.componentInstance.emailSubject = "";
        dialogRef.componentInstance.emailBody = "";
        //dialogRef.componentInstance.notes = dataItem.comment;

        dialogRef.afterClosed().subscribe(result => {
            //console.log(result);
            if (result.btnOK == true) {
                console.log("sendAvailableLoadOfferEmail", quoteOrderLineID, result);
                this.emailService.sendAvailableLoadOfferEmail(quoteOrderLineID, result.emailTo, result.emailCC).subscribe(result => {
                    var ok = result;
                },
                    err => {
                        console.log(err);
                    }
                );
            }
        });
    }
}
